import axios from "axios";
const responseFormat = { error: "", data: null };
const { API_BACKEND_HOST } = process.env;

export const newRole = async (request) => { 
  const languageId = localStorage.getItem("i18nextLng");
  try {
    const response = await axios.post(
      `${API_BACKEND_HOST}${languageId}/v1/GeneralRule`,
      request
    );
    responseFormat.data = response;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error =
      response.data.errors || "Erro ao tentar criar a regral geral";
    return responseFormat;
  }
};

export const updateRole = async (id, request) => {
  const languageId = localStorage.getItem("i18nextLng");
  try {
    const response = await axios.put(
      `${API_BACKEND_HOST}${languageId}/v1/GeneralRule/${id}`,
      request
    );
    responseFormat.data = response;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error =
      response.data.errors || "Erro ao tentar editar a regral geral";
    return responseFormat;
  }
};


export const getAllRoles = async ({
}) => {
  
  try {
    const languageId = localStorage.getItem("i18nextLng");
    const { data } = await axios.get(`${API_BACKEND_HOST}${languageId}/v1/GeneralRule`, {
    });
    responseFormat.data = data;
    responseFormat.error = "";
     return responseFormat;
  } catch (response) {
    responseFormat.error = "async";
    return responseFormat;
  }
};

export const getRoleById = async (id) => {
  try {
    
    const languageId = localStorage.getItem("i18nextLng");
    const { data } = await axios.get(`${API_BACKEND_HOST}${languageId}/v1/GeneralRule/${id}`, {
      params: {
        id,
      },
    });
    responseFormat.data = data;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error = "async";
    return responseFormat;
  }
};

export const deleteRole = async ( id ) => {
  try {
    
    const languageId = localStorage.getItem("i18nextLng");
    const { data } = await axios.delete(
      `${API_BACKEND_HOST}${languageId}/v1/GeneralRule/${id}`
    );
    responseFormat.data = data;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error = response.data.errors[0] || " ";
    return responseFormat;
  }
};